import { useNumberFormatter } from '@diana/core';
import { Box } from '@mui/system';

export const NumberCell = ({
  decimals,
  displayAllDecimals,
  value,
}: {
  decimals?: number;
  displayAllDecimals?: boolean;
  value: number;
}) => {
  const number = useNumberFormatter(decimals, displayAllDecimals);
  return <Box>{number.format(value)}</Box>;
};
